<template>
  <div class="fts-skeleton" :style="style"></div>
</template>

<script>
export default {
  props: {
    avatar: Boolean,
    height: String,
    width: String,
    size: String,
  },
  computed: {
    style() {
      if (this.avatar) {
        return {
          "border-radius": "50%",
          "height": this.size || this.height,
          "width": this.size || this.width,
        }
      } else {
        return {
          "height": this.height,
          "width": this.width
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/assets/scss/vars.scss";

.fts-skeleton {
  position: relative;
  overflow: hidden;
  border-radius: .25rem;
  background: var(--fts-gray-1);
  will-change: transform;
  &:after {
    position: absolute;
    display: block;
    height: 100%;
    width: 100%;
    content: "";
    transform: translateX(-100%);
    animation: loading 2s infinite;
    // background: -webkit-gradient(linear, left top, right top, from(transparent), color-stop(#{$skeleton-loading-color}), to(transparent));
    @include theme() {
      background: linear-gradient(110deg, 
        #{rgba($color: theme-get('fts-gray-2'), $alpha: 0)} 0%,
        #{rgba($color: theme-get('fts-gray-2'), $alpha: .15)} 20%,
        #{rgba($color: theme-get('fts-gray-2'), $alpha: .5)} 40%,
        #{rgba($color: theme-get('fts-gray-2'), $alpha: .75)} 60%,
        #{rgba($color: theme-get('fts-gray-2'), $alpha: .15)} 80%,
        #{rgba($color: theme-get('fts-gray-2'), $alpha: 0)} 100%
      );
    }
  }
  @keyframes loading {
    100% {
      transform: translateX(100%);
    }
  }
}
</style>